import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Cookies from 'universal-cookie';
import GlobalTooltip from 'components/GlobalTooltip';
import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

const docTypeVal = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const cookie = new Cookies();

function SignatureTemplate({ rowData }) {
  const history = useHistory();
  const { modals, setSelectedItem, isClientFileManager, isLeadFileManager } = useFileManagerContext();

  let condition = rowData?.file_type && (rowData?.file_type === 'application/pdf' || rowData?.file_type === docTypeVal);
  const status = rowData?.esignature_status?.toLowerCase();

  // Check if signature request has expired
  const isExpired = () => {
    // rowData.esignature_request.expiry_date_epoch = 1764315504
    if (!rowData?.esignature_request?.expiry_date_epoch) return false;
    if (status !== 'pending') return false;
    const currentTime = Date.now();
    const expiryTime = rowData.esignature_request.expiry_date_epoch;
    // Check if current time is greater than expiry time (expiry has passed)
    return currentTime > expiryTime;
  };

  const expired = isExpired();

  const redirectFileDetails = () => {
    let data = {};
    let currentUser = cookie.get('userId') || null;
    data.file_pk = rowData.pk;
    data.file_sk = rowData.sk;
    data.user_id = currentUser;

    let obj = {
      case_id: rowData.case_id,
      file_pk: rowData?.pk,
      file_sk: rowData?.sk,
      data: {},
      is_lead: isLeadFileManager,
    };
    history.push({
      pathname: '/sign-document',
      state: obj,
    });
  };

  const renderStatusContent = () => {
    if (status === 'pending') {
      return (
        <span className="d-inline-flex align-items-center gap-2">
          <span className="d-inline-flex align-items-center gap-1 sign-waiting">
            <i className="pi pi-info-circle info-style me-1" />
            {expired ? 'Expired' : 'Pending'}
          </span>

          {isClientFileManager && !expired && (
            <div
              className="cursor-pointer p-button-secondary ms-2 d-inline-flex align-items-center gap-1"
              onClick={() => redirectFileDetails()}
            >
              <i className="icon-signature" />
              <span className="text-white">Sign</span>
            </div>
          )}
        </span>
      );
    }

    if (status === 'signed') {
      return (
        <span className="d-inline-flex align-items-center gap-1 signed-file">
          <i className="fas fa-check text-success" />
          Signed
        </span>
      );
    }

    return 'Not Requested';
  };

  return (
    <>
      <span className="p-column-title text-break">Signature</span>
      {condition ? (
        isClientFileManager ? (
          <span className="text-break">{renderStatusContent()}</span>
        ) : (
          <>
            <div
              className="signature-icon-container pointer d-inline-block me-2"
              onClick={() => {
                setSelectedItem(rowData);
                modals.setShowSignatureModal(true);
              }}
            >
              <i className="icon-signature" />
            </div>

            <GlobalTooltip tooltip={expired ? 'Signature Request Expired' : rowData?.esignature_status}>
              <i
                className="fas fa-circle signature-target-icon capitalize cursor-pointer"
                data-pr-tooltip={expired ? 'Signature Request Expired' : rowData?.esignature_status}
                style={{
                  color: expired ? 'red' : status === 'pending' ? 'yellow' : status === 'signed' ? 'green' : 'transparent',
                }}
                onClick={() => {
                  setSelectedItem(rowData);
                  modals.setEsignStatusModal(!modals.showEsignStatusModal);
                }}
              />
            </GlobalTooltip>

            <span className="ms-2">{renderStatusContent()}</span>
          </>
        )
      ) : (
        <span>-</span>
      )}
    </>
  );
}

export default SignatureTemplate;
